module.exports = __webpack_public_path__ + "static/media/discord_bot.fb0f6887.png";